var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CalendarMonth',{attrs:{"load-calendar-events":_vm.loadCalendarEvents,"parent-object":_vm.parentObject}})}
var staticRenderFns = []

export { render, staticRenderFns }